export default __webpack_public_path__ + "static/media/09.c42b2b62.jpg";